import axios from 'axios';

export interface ConnectedAccountDTO {
  id: number;
  provider: 'google' | 'microsoft' | 'linkedin';
  email: string;
  displayName: string | null;
  scopes: string[];
  isPrimaryForSend: boolean;
  isPrimaryForCalendar: boolean;
  isActive: boolean;
  canSendEmail: boolean;
  canReadEmail: boolean;
  canUseCalendar: boolean;
  lastSyncedAt: string | null;
  lastSyncError: string | null;
  // Google rejected the saved grant; only reconnecting the account can resume email sync.
  needsReauth: boolean;
  createdAt: string;
}

export interface SyncResult {
  success: boolean;
  added: number;
  scanned: number;
  skipped: number;
  errors: string[];
}

export const connectedAccountsApi = {
  list: async (): Promise<ConnectedAccountDTO[]> => {
    const { data } = await axios.get<{ accounts: ConnectedAccountDTO[] }>(
      '/api/connected-accounts',
    );
    return data.accounts;
  },

  disconnect: async (id: number): Promise<void> => {
    await axios.delete(`/api/connected-accounts/${id}`);
  },

  setPrimary: async (id: number, capability: 'send' | 'calendar'): Promise<void> => {
    await axios.post(`/api/connected-accounts/${id}/primary`, { capability });
  },

  syncNow: async (id: number): Promise<SyncResult> => {
    const { data } = await axios.post<SyncResult>(`/api/connected-accounts/${id}/sync`);
    return data;
  },
};
